import { useEffect } from 'react';
import { useWorkOrderData, useWorkOrderSelection } from '../../../context/WorkOrdersContext';
import { notifyAssetDeleted } from '../../../hooks/notifyAssetDeleted';

// Renders nothing. Lives apart from the selection context so selecting never re-renders the page;
// keyed on the flag, not the orders, so a refetch doesn't raise the popup again.
const SelectedWorkOrderAssetNotice = () => {
  const { selectedId } = useWorkOrderSelection();
  const { orders } = useWorkOrderData();
  const hasDeletedAsset = selectedId !== null && orders.find((order) => order.id === selectedId)?.hasDeletedAsset;

  useEffect(() => {
    if (selectedId !== null && hasDeletedAsset) notifyAssetDeleted(selectedId);
  }, [selectedId, hasDeletedAsset]);

  return null;
};

export default SelectedWorkOrderAssetNotice;
